import { render, staticRenderFns } from "./Tab-insert-invoice-local.vue?vue&type=template&id=f9ad7524"
import script from "./Tab-insert-invoice-local.vue?vue&type=script&lang=js"
export * from "./Tab-insert-invoice-local.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports